import React from 'react';
import {InfiosBurgerLine, InfiosBurgerWrapper} from "./HeaderBurger.style";

const HeaderBurger = (props) => {
    const { className, onClick, blackLetter, isMobile } = props;

    return (
        <InfiosBurgerWrapper onClick={onClick} className={className} isMobile={isMobile}>
            <InfiosBurgerLine blackLetter={blackLetter} isMobile={isMobile}/>
            <InfiosBurgerLine blackLetter={blackLetter} isMobile={isMobile}/>
            <InfiosBurgerLine blackLetter={blackLetter} isMobile={isMobile}/>
            <InfiosBurgerLine blackLetter={blackLetter} isMobile={isMobile}/>
        </InfiosBurgerWrapper>
    )
}

export default HeaderBurger;
